import {Component, OnInit, OnDestroy} from '@angular/core';
import {BusinessDataService} from '../../../../../data-repositories/business-data.service';
import {User} from '../../../../../models/user';
import {Subscription} from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-personal-first-holder',
  templateUrl: './personal-first-holder.component.html',
  styleUrls: ['./personal-first-holder.component.scss']
})
export class PersonalFirstHolderComponent implements OnInit, OnDestroy {
  user: User;
  private subscription = new Subscription();

  constructor(
    private service: BusinessDataService) {

    this.subscription.add(this.service.GetUser().subscribe(s => {
      this.user = s.model;
    }));
  }

  ngOnInit() {
  }

  public updateUser(): void {
    this.service.updateUserWithoutValidation(this.user, () => {
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
